import { ReactNode } from "react";
import { Link, useLocation } from "react-router";
import { useMsal } from "@azure/msal-react";
import { useLoginHeartbeat } from "../auth/useLoginHeartbeat";
import { useIsAdmin } from "../auth/useIsAdmin";
import { useIsAccounting } from "../auth/useIsAccounting";

type NavItem = { to: string; label: string; adminOnly?: boolean; accountingOnly?: boolean };

const nav: NavItem[] = [
  { to: "/", label: "Panel" },
  { to: "/pedidos", label: "Pedidos venta" },
  { to: "/albaranes", label: "Albaranes" },
  { to: "/facturas", label: "Facturas" },
  { to: "/intermediacion", label: "Intermediación", adminOnly: true },
  { to: "/informes", label: "Informes" },
  { to: "/contabilidad", label: "Contabilidad", accountingOnly: true },
  { to: "/admin/logins", label: "Logins", adminOnly: true },
];

export default function Layout({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const { isAdmin } = useIsAdmin();
  const { isAccounting } = useIsAccounting();
  // Fire-and-forget audit ping; dedupes on server and in-tab.
  useLoginHeartbeat();

  const visibleNav = nav.filter(
    (item) =>
      (!item.adminOnly || isAdmin) && (!item.accountingOnly || isAccounting),
  );

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-brand-band text-white">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" title="Aginco Portal">
              <img src="/logo_blanco.png" alt="Aginco Portal" className="h-8 w-auto" />
            </Link>
            <nav className="flex gap-4 text-sm">
              {visibleNav.map((item) => {
                const isActive = item.to === "/"
                  ? location.pathname === "/"
                  : location.pathname === item.to || location.pathname.startsWith(item.to + "/");
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className={`py-1 px-2 rounded-md transition-colors ${
                      isActive ? "bg-white/25 font-semibold" : "hover:bg-white/10"
                    }`}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-4 text-sm">
            <span>{account?.username}</span>
            <button
              onClick={() => instance.logoutRedirect()}
              className="text-white/80 hover:text-white underline"
            >
              Salir
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-8">
        {children}
      </main>

      <footer className="bg-gray-100 text-brand-gray text-xs py-4 text-center">
        © 2026 Aginco — Agencia Internacional de Comercio, S.L.
      </footer>
    </div>
  );
}
